import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { sectionTitleSx, sectionAccentLineSx } from "../../theme";

type SectionTitleProps = {
    children: ReactNode;
};

/**
 * Единый стиль заголовка секции для главной, «Питомцы», «О животных» и т.д.
 */
export default function SectionTitle({ children }: SectionTitleProps) {
    return (
        <Typography variant="h2" sx={sectionTitleSx}>
            {children}
            <Box component="span" sx={sectionAccentLineSx} />
        </Typography>
    );
}
